import initialState from "../../reducers/initialState";
import * as types from 'actions/actionTypes'

export default function (state = initialState.reducerItemListCampFollowUserTypes, action) {

    
    switch (action.type) {
        // case types.ITEM_LIST_MAN_HOURS_FULFILLED:
        case types.ITEM_LIST_PRODUCT_CODE_TRANSLATION_FULFILLED:
            return {
                itemListProductCodeTanslation: action.payload ? action.payload.data.itemList : [{}],
            }
        default:
            return state;
    }

}